module.exports = __webpack_public_path__ + "img/madera002.c584ba1a.jpg";